// -----------------------------------------------------------
// FloraIQ - Aviso de modulo/secao sem dado real
// -----------------------------------------------------------
// Usado onde a tela existia so com dado ficticio. Diz o que falta em vez de
// mostrar numero inventado.

export interface NoRealDataProps {
  /** O que esta secao vai mostrar quando houver dado (ex.: "Projetos de carbono"). */
  title: string;
  /** De onde o dado vai vir ou o que falta para existir. */
  description?: string;
  icon?: string;
  /** "page" ocupa a area principal; "section" cabe dentro de um cartao. */
  variant?: "page" | "section";
}

export default function NoRealData({
  title,
  description = "Ainda não há dado real para esta seção.",
  icon = "ri-database-2-line",
  variant = "section",
}: NoRealDataProps) {
  const padding = variant === "page" ? "py-20" : "py-10";
  return (
    <div
      className={`flex flex-col items-center justify-center ${padding} px-4 text-center bg-white rounded-xl border border-dashed border-background-200`}
    >
      <div className="w-12 h-12 rounded-full bg-background-100 flex items-center justify-center mb-3">
        <i className={`${icon} text-xl text-foreground-400`}></i>
      </div>
      <h3 className="text-sm font-semibold text-foreground-800 font-heading mb-1">{title}</h3>
      <p className="text-xs text-foreground-500 max-w-md">{description}</p>
    </div>
  );
}
